<!--
 * @Author: ‘巴博尔’ 2164119982@qq.com
 * @Date: 2023-10-27 10:43:55
 * @LastEditors: ‘巴博尔’ 2164119982@qq.com
 * @LastEditTime: 2023-11-08 14:09:46
 * @FilePath: \admin_pc\src\views\user-by-lesson-card\UserBuyLessonCardBs.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 基础游会员列表 -->
<!--基础游会员卡-->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <!-- <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div> -->
    <template v-if="contentShow">
      <el-card class="operate-container" shadow="never">
        <div class="filter-container">
          <el-form :inline="true" :model="queryParam" label-width="80px">
            <!-- <el-form-item label="课程卡:" label-width="60px">
              <el-select v-model="queryParam.lessonCardId" placeholder="请选择" style="width: 120px">
                <el-option v-for="item in storeLessonCards" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="版本:" label-width="100px">
            <el-select v-model="queryParam.lessonCardId" placeholder="选择版本" style="width: 147px">
              <el-option v-for="item in storeLessonsList" :key="item.storeLessonId" :label="item.name"
                :value="item.storeLessonId">
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="会员名:" label-width="60px">
              <el-input v-model="queryParam.childName" placeholder="请输入姓名" style="width: 120px"></el-input>
            </el-form-item>
            <el-form-item label="家长手机:" label-width="80px">
              <el-input v-model="queryParam.userPhone" placeholder="请输入手机号" maxlength="11"
                style="width: 120px"></el-input>
            </el-form-item>
            <!-- <el-form-item label="家长姓名:">
            <el-input
              v-model="queryParam.userName"
              placeholder="输入姓名"
            ></el-input>
          </el-form-item> -->
            <el-form-item label="卡状态:" prop="userPhone" label-width="60px">
              <el-select v-model="queryParam.status" placeholder="请选择状态" style="width: 120px">
                <el-option v-for="item in [
                  { label: '使用中', value: 0 },
                  { label: '已停卡', value: 1 },
                ]" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="卡类型:" prop="userPhone" label-width="60px">
              <el-select v-model="queryParam.storeLessonCardId" placeholder="请选择类型" style="width: 120px">
                <el-option v-for="item in fechListList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="剩余课时起止:" prop="userPhone" label-width="110px">
              <el-input-number style="width: 120px" v-model="queryParam.startHost" placeholder=""
                :min="0"></el-input-number>
              <i>--</i>
              <el-input-number style="width: 120px" v-model="queryParam.endHost" placeholder=""
                :min="0"></el-input-number>
            </el-form-item>
            <el-form-item style="margin-left: 10px">
              <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
                询</el-button>
              <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
                @click="handleResetSearch()" style="margin-left: 10px">重 置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
      <div class="app-container-content">
        <!--    查询结果区域-->
        <div class="title-container" shadow="never" style="padding-top: 20px">
          <!-- <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表 双击复制表格内容</span>
      </div> -->
          <div></div>
          <div class="d-flex">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit"
              @click="onUpdateChildInfoShow()">编辑</el-button>
            <!-- <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-picture-outline"
            @click="handelChildPhoto()"
            >照片墙</el-button
          > -->
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-set-up"
              @click="handleUpdateCardShowDlg()">卡项调整</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-remove-outline"
              @click="handleDeductionShowDlg()">扣课</el-button>
              <div class="spec-buton-box" >
                <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-time"
              @click="handleBookLesson(1)">固定预约</el-button>
                <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
              </div>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-video-pause"
              @click="handleStopCardShowDlg()">停开卡</el-button>
            <!-- <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-time"
            @click="handleActitity()"
            >活动预约</el-button
          > -->
          <div class="spec-buton-box">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-money"
              @click="handleExtendAllCardDayShowDlg()">Date</el-button>
            <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
          </div>
          <div class="spec-buton-box">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-reading"
              @click="handleUpAgreement()">合同</el-button>
              <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
          </div>
          <div class="spec-buton-box">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-sort"
              @click="handleDIGShunt()">分流</el-button>
              <img class="spec-img" src="@/statics/imgs/svip.png" alt="" />
          </div>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-reading"
              @click="handleCreateOneDlg()">购卡</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-postcard"
              @click="handleRenewalsCardShowDlg()">续卡</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-time"
              @click="handleBookLesson(2)">预约</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-reading" style="margin-right: 23px"
              @click="handleFilesUpload()">导入</el-button>

            <!-- <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-refresh-right"
            @click="handlereStartCardShowDlg()"
            >重开卡</el-button
          > -->
          </div>
        </div>
        <div class="table-container" style="margin-top: 20px">
          <!-- @select="clickSelect" @select-all="clickselectAll" -->
          <el-table :data="tableData" @cell-dblclick="celldblclick" :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }" highlight-current-row :span-method="objectSpanMethod" 
            @row-click="rowClick" style="font-size: 10px"
            v-loading="listLoading" border   @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="30"> </el-table-column>
            <el-table-column prop="id" label="卡号" width="80" :show-overflow-tooltip="true" > </el-table-column>
            <el-table-column prop="userPhone" label="手机号" width="110"></el-table-column>
            <el-table-column prop="childName" label="会员名" width="80" :show-overflow-tooltip="true" ></el-table-column>
            <el-table-column prop="lessonTemplateType" label="业务类型"></el-table-column>
            <el-table-column prop="useTypeDes" label="使用类型"></el-table-column>
            <el-table-column prop="cardName" label="卡类型" :show-overflow-tooltip="true" width="70"></el-table-column>
            <!--<el-table-column prop="userName" label="家长" ></el-table-column>-->
            <el-table-column prop="monthC" label="月龄"  width="45"></el-table-column>
            <el-table-column prop="childTypeDes" label="宝贝类型" width="70"></el-table-column>
            <el-table-column prop="totalLesssonCountDes" label="总课时(正价/赠送)" width="110"></el-table-column>
            <el-table-column prop="totalPay" label="购买金额" width="70"></el-table-column>
            <el-table-column prop="remainingClassDes" label="剩余课时" width="90"></el-table-column>
            <el-table-column prop="remTotalPay" label="剩余金额" width="80"></el-table-column>
            <el-table-column prop="cardStartTime" label="生效时间" width="95"></el-table-column>
            <el-table-column prop="cardEndTime" label="到期时间" width="95"></el-table-column>
            <el-table-column prop="valDay" label="有效期" width="65"></el-table-column>
            <el-table-column prop="statuDes" label="状态"  width="55"></el-table-column>
            <el-table-column prop="gold" label="金币" width="45"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" width="150">
              <template slot-scope="scope">
                <div style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
                  <p>{{ scope.row.remark }}</p>
                  <img v-if="scope.row.recordingTo" @click="clickAudio(scope.row)"
                    style="width: 25px; height: 25px; margin-left: 5px;cursor: pointer;" src="@/assets/icons/laba.png"
                    alt="" />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="detail" label="操作" width="120">
              <template slot-scope="scope">
                <!-- <el-button
                type="primary"
                size="mini"
                @click="handleDetail(scope.$index, scope.row)"
                >查看详情</el-button
              >
              <el-button
                type="warning"
                size="mini"
                @click="goGoldExchange(scope.row)"
                >金币操作</el-button
              > -->
                <el-button class="vip-button" type="text" size="mini" @click="goGoldExchange(scope.row)">金</el-button>
                <el-button type="text" size="mini" @click="clickOpenModelBtns(scope.row, 1)">订</el-button>
                <el-button class="vip-button" type="text" size="mini" @click="clickOpenModelBtns(scope.row, 2)">会</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper" :current-page.sync="queryParam.pageNum"
          :page-size="queryParam.pageSize" :page-sizes="queryParam.pageSizes" :total="queryParam.totalPage">
        </el-pagination>
      </div>
    </template>

    <!-- 详情弹出页 -->
    <!--user-detail-info :user-detail-info="detailInfo"></user-detail-info>-->

    <el-dialog title="订单详情 / 购卡详情" :visible.sync="visibleDetail" width="50%" center>
      <div>
        <el-form ref="registerRef" label-width="150px">
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">性别 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.gender }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">手机号 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.userPhone }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">学员姓名 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.childName }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">购卡的卡名称 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.cardName }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">卡类型 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.experience }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">开卡时间 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.createTime }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">购卡次数 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{
                  detailInfo.totalLesssonCount
                }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">赠送次数 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{
                  detailInfo.totalGiveCount
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">总金额 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.totalPay }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">优惠金额 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.givenPay }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">开卡金额 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.realPay }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">剩余金额 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.remTotalPay }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">邀约人 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.inviteWorker }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">成单人1 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.buyCardWorker }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">成单人2 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{
                  detailInfo.buyCardWorkerTwo
                }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">来源1 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.source }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">来源2 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.sourceTwo }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">礼品: </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.gift }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">金币: </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.gold }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row tag="span">
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">备注 : </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2">
                <span class="dialog_span2">{{ detailInfo.remark }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div1">
                <span class="dialog_span1">备注附件: </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="dialog_div2" v-for="item in detailInfo.buyRemarkFileList" :key="item.id">
                <a :href="item.filePath" target="_blank">{{ item.content }}</a>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDetail = false">取消</el-button>
      </span>
    </el-dialog>

    <!--    添加-->
    <el-dialog title="家长购卡" :visible.sync="visibleVipUpdateType" width="800px" center>
      <UpdateVipTypeInfo ref="UpdateVipTypeInfo" :child-id="updateChildId" @onBtnCancel="visibleVipUpdateType = false"
        @handleUpdate="handleUpdatevisibleVipUpdateType" :store-lesson-exp-cards="storeLessonEXPCards" />
    </el-dialog>
    <!-- <buy-lesson-card-detail :key="refreshCard" :show="showAddCardDlg" @onBtnOK="handleCreateOne"
      :store-lesson-cards="storeLessonCards"></buy-lesson-card-detail> -->
    <!--    预约课程-->
    <template v-if="visibleDlgBookThree">
      <el-dialog :title="handleBookLessonNum == 1 ? '固定预约' : '临时预约'" :visible.sync="visibleDlgBookThree" width="800px"
        center>
        <BookLessonForChildThree ref="onForChild" :is-vip="true" :lesson-template-id="lessonTemplateId"
          @onBookSuccess="onBookSuccess" :vip-child="selectRow" :numfrom="handleBookLessonNum"
          @onBtnCancel="visibleDlgBookThree = false" />
      </el-dialog>
    </template>
    <!--    预约活动-->
    <el-dialog title="预约课程" :visible.sync="visibleDlgBook" width="50%" center>
      <book-lesson-for-child :is-vip="true" :lesson-template-id="lessonTemplateId" :key="refreshBookDlg"
        @onBookSuccess="onBookSuccess" :vip-child="selectRow">
      </book-lesson-for-child>
    </el-dialog>
    <!--停卡-->
    <template v-if="visibleStopCard">
      <el-dialog title="停开卡" :visible.sync="visibleStopCard" width="900px" top="11vh" center>
        <warningAddCard :card-info="selectRow" @onBtnCancel="visibleStopCard = false"
          @onBtnCreate="handleCurrentCardEvent" />
        <!-- <div>
        <el-card style="margin-top: -20px">
          <span>卡基本信息</span>
          <card-info :card-info="cardInfo"></card-info>
        </el-card>

        <el-card style="margin-top: 10px">
          <span>设置停卡日期范围</span>
          <el-date-picker
            style="width: 98%; margin-top: 10px"
            v-model="stopCardDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始"
            end-placeholder="结束"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleStopCard = false">取消</el-button>
        <el-button type="warning" @click="handleStopCard()">确认</el-button>
      </span> -->
      </el-dialog>
    </template>
    <!--重开卡-->
    <el-dialog title="重开卡" :visible.sync="visibleRestartCard" width="50%" center>
      <div>
        <el-card style="margin-top: -20px">
          <span>卡基本信息</span>
          <card-info :card-info="cardInfo"></card-info>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleRestartCard = false">取消</el-button>
        <el-button type="warning" @click="handleRestartCard()">确认</el-button>
      </span>
    </el-dialog>
    <!--调整卡-->
    <el-dialog title="卡项变更" :visible.sync="visibleUpdateCard" width="50%" top center>
      <el-row>
        <el-col :span="12">
          <div>
            <el-card style="height: 550px">
              <span>卡基本信息</span>
              <card-info :card-info="cardInfo"></card-info>
            </el-card>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-card style="height: 550px">
              <span>设置调整数值</span>
              <div class="root-container" style="margin-top: 10px">
                <el-form ref="registerRef" label-width="150px" size="small">
                  <el-form-item label="剩余正价课时:" v-if="cardInfo.consumeType != 1">
                    <el-input-number v-model="updateCardParam.remTotalCount" placeholder=""></el-input-number>
                  </el-form-item>
                  <el-form-item label="剩余赠送课时:" v-if="cardInfo.consumeType != 1">
                    <el-input-number v-model="updateCardParam.remGiveCount" placeholder=""></el-input-number>
                  </el-form-item>
                  <el-form-item label="金额:">
                    <el-input-number v-model="updateCardParam.pay" placeholder=""></el-input-number>
                  </el-form-item>
                  <el-form-item label="时间:" prop="" v-if="cardInfo.consumeType == 1">
                    <el-date-picker v-model="updateCardParam.value1" value-format="yyyy-MM-dd" type="daterange"
                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 270px">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="频率:" prop="" v-if="cardInfo.consumeType == 1">
                    <div style="display: flex;">
                      <el-input-number v-model="updateCardParam.frequency" style="width: 200px"
                        :min="0"></el-input-number>
                      (课/周)
                    </div>
                  </el-form-item>
                  <el-form-item label="有效期:" v-if="cardInfo.consumeType != 1">
                    <el-date-picker style="width: 100%" v-model="updateCardParam.updateEndDate" type="date"
                      placeholder="">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="卡使用类型:" prop="useType">
                    <el-select v-model="updateCardParam.useType" placeholder="请选择">
                      <el-option v-for="item in cardUseTypeList" :key="item.v" :label="item.des" :value="item.v">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注:">
                    <el-input v-model="updateCardParam.remark" placeholder=""></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleUpdateCard = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateCard()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="续卡" :visible.sync="visibleDlgrenewal" width="800px" top="1vh" center>
      <el-row>
        <el-col :span="12">
          <el-card style="height: 550px">
            <a>卡基本信息</a>
            <card-info :card-info="cardInfo"></card-info>
          </el-card>
        </el-col>
        <el-col :span="12">
          <div>
            <el-card style="height: 550px">
              <span style="margin-bottom: 10px">续卡设置</span>
              <div class="root-container">
                <el-form ref="registerRef" label-width="100px" size="small">
                  <el-form-item label="卡类型">
                    <el-select v-model="renewalParam.lessonCardId" placeholder="请选择">
                      <el-option v-for="item in storeLessonCards" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="金额">
                    <el-input-number v-model="renewalParam.pay" placeholder=""></el-input-number>
                  </el-form-item>
                  <el-form-item label="邀约人">
                    <el-select v-model="renewalParam.inviteWorker" placeholder="请选择">
                      <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="成单人">
                    <el-select v-model="renewalParam.buyCardWorker" placeholder="请选择">
                      <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgrenewal = false">取消</el-button>
        <el-button type="warning" @click="handlerenewal()">确认</el-button>
      </span>
    </el-dialog>
    <!--    修改会员信息-->
    <el-dialog title="编辑" :visible.sync="visibleDlgUpdateChildInfo" width="900px" center>
      <update-child-info :key="updateRefresh" :child-id="updateChildId" @onBtnCancel="onBtnCancelUpdate" type="A"
        @handleUpdate="handleUpdateChild"></update-child-info>
    </el-dialog>
    <el-dialog title="给所有有效会员卡续期" :visible.sync="visibleDlgExtentCardDay" width="600px" center>
      <extent-card-day :lesson-template-id="lessonTemplateId" @onBtnOk="handleExtendAllCardDay"></extent-card-day>
    </el-dialog>
    <worker-word :title="wordTitle" :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
    <template v-if="visibleDlgDeduction">
      <el-dialog title="扣课" :visible.sync="visibleDlgDeduction" width="900px" center>
        <DeductionOfClasses :childInfo="selectRow" @onBtnCancel="visibleDlgDeduction = false"
          @handleUpdate="handleUpdateDeduction" />
      </el-dialog>
    </template>
    <template v-if="visibleUploadContract">
      <el-dialog title="合同" :visible.sync="visibleUploadContract" width="800px" center>
        <UploadContract :queryData="selectRow" />
      </el-dialog>
    </template>
    <template v-if="visibleDlogShunt">
      <el-dialog title="分流" :visible.sync="visibleDlogShunt" width="500px" center>
        <shunt :card-info="selectRow" :selectList="selectList" @onBtnCancel="visibleDlogShunt = false"
          @onBtnCreate="handleStopShunt()" />
      </el-dialog>
    </template>
    <template v-if="visibleFileupload">
      <el-dialog title="会员卡导入" :visible.sync="visibleFileupload" width="500px" center>
        <cardExportFile :currentType="2"></cardExportFile>
        <!-- <el-button type="primary" size="medium" style="margin-bottom: 20px"
          >下载模板</el-button
        >
        <fileUpload
          :fileType="['xls', 'xlsx', 'xlsm', 'xlsb', 'csv']"
          :fileSize="5"
          :limit="1"
          @input="fileUploadSuccess"
        /> -->
      </el-dialog>
    </template>
    <template v-if="visibleVipModelShow">
      <el-dialog title="会员详情" :visible.sync="visibleVipModelShow" width="1000px" center>
        <vipModel :vipInfo="vipInfo"/>
      </el-dialog>
    </template>
    <template v-if="!contentShow">
      <orderDetails :child-id="detailId" />
    </template>
    <template v-if="audioDialog">
      <el-dialog title="音频文件" width="500px" :visible.sync="audioDialog" center>
        <audioDialog ref="audioDialogRef" />
      </el-dialog>
    </template>
  </div>
</template>

<style scoped lang="scss">
/deep/ .el-table th.el-table__cell>.cell {
  // width: 90%;
  height: 100%;
  background: #ecf3fd;
  // border-radius: 8px;
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
  margin-top: 10vh !important;

}
/deep/.el-dialog{
  margin-top: 10vh !important;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

.dialog_div1 {
  padding-bottom: 14px;
  text-align: right;
}

.dialog_div2 {
  padding-bottom: 14px;
  text-align: left;
}

.dialog_span1 {
  font-size: 15px;
  color: #0d6fb8;
  padding-right: 10px;
}
/deep/ .operator-btn{
  margin-left: 1px !important;
}
.dialog_span2 {
  font-size: 14px;
  font-weight: normal;
}

.app-container {
  .operate-container {
    border: none;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .root-container {
    width:100% ;
    .el-form-item {
      margin-bottom: 20px;
    }
  }
  /deep/ .el-card__body {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  &-content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
  }

  .table-container {
    border: none;
    border-radius: 0px;

    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 0px;
        }
      }
    }
  }

  /deep/ .el-form--inline {
    text-align: initial;
  }
  /deep/ .el-table__row{
    font-size: 14px !important;
  }
}
</style>

<script>
import {
  qlUserByCardChild,
  renewalsCard,
  reStartBuyCard,
  stopBuyCard,
  updateCardDetail,
} from "../../api/userByCard";
import {
  fechListLessonVipCard
} from "@/api/StoreLessonCard";
import commonUtils from "../../utils/commonUtils";
import globaldata from "../../utils/globaldata";
import { findVipUser, selectCard } from "../../api/storeFront";
import messageUtils from "../../utils/messageUtils";
import BuyLessonCardDetail from "./components/BuyLessonCardDetail";
import WorkerWord from "../../components/WorkerWord/WorkerWord";
import timeUtils from "../../utils/timeUtils";
import enumsUtil, {
  EUserBuyCardStatu,
  ECardUseType,
  getEnumDesByV,
} from "../../utils/enumsUtil";
import { qlLessonTemplate } from "@/api/StoreLesson";
import UpdateVipTypeInfo from "../user_child/components/UpdateVipTypeInfo";
import CardInfo from "./components/CardInfo";
import BookLessonForChild from "../components/BookLessonForChild";
import BookLessonForChildThree from "../components/BookLessonForChildThree";
// import UpdateChildInfo from "../user_child/components/UpdateChildInfo";
import UpdateChildInfo from "./components/UpdateChildInfo";
import ExtentCardDay from "./components/ExtentCardDay";
import UserDetailInfo from "./components/UserDetailInfo";
import DeductionOfClasses from "./components/DeductionOfClasses";
import warningAddCard from "./components/warningAddCard";
import UploadContract from "./components/UploadContract";
import shunt from "./components/shunt";
import vipModel from "./components/vipModel";
import orderDetails from "./components/orderDetails";
import fileUpload from "@/components/Upload/fileUpload";
import audioDialog from "@/components/audioDialog";
import cardExportFile from './components/CardExport.vue'

export default {
  components: {
    UserDetailInfo,
    ExtentCardDay,
    UpdateChildInfo,
    BookLessonForChild,
    BookLessonForChildThree,
    CardInfo,
    WorkerWord,
    BuyLessonCardDetail,
    DeductionOfClasses,
    warningAddCard,
    UploadContract,
    shunt,
    fileUpload,
    vipModel,
    orderDetails,
    audioDialog,
    UpdateVipTypeInfo,
    cardExportFile
  },
  data() {
    return {
      vipInfo:{},
      storeLessonEXPCards:[],
      storeLessonsList: [],
      selectList: [],
      contentShow: true,
      listLoading: true,
      visibleVipUpdateType: false,
      //弹窗
      audioDialog: false,
      visibleDlgAdd: false,
      visibleDlgrenewal: false,
      visibleStopCard: false,
      visibleDlgBook: false,
      visibleDlgBookThree: false,
      visibleRestartCard: false,
      visibleUpdateCard: false,
      visibleDlgUpdateChildInfo: false,
      visibleDlgExtentCardDay: false,
      visibleDetail: false,
      visibleDlgDeduction: false,
      visibleUploadContract: false,
      visibleDlogShunt: false,
      visibleFileupload: false,
      visibleVipModelShow: false,
      selectRow: null,
      handleBookLessonNum: 1,
      //查询参数
      queryParam: {
        payTime: "",
        storeLessonCardId: '',
        startHost: undefined,
        status: '',
        endHost: undefined,
        status: '',
        cardTime: "",
        totalPay: "3000",
        sliderValue: [0, 500],
        sliderMarks: {
          0: "0",
          100: "100",
          500: "500",
        },
        remark: "备注", // 剩余课时
        lessonCardId: "", //课程卡Id
        userName: "",
        childName: "",
        userPhone: "", //家长手机号

        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共数
        pageSize: 10,
        pageSizes: [10, 20, 30],
      },
      multipleSelection: [], //选择的表单
      //表单结果
      tableData: [],
      storeLessonCards: [], //店铺所有的课程卡
      lessonCardTemplate: [],
      showAddCardDlg: false,
      refreshBookDlg: "",
      refreshCard: "",
      //添加参数
      createParam: {
        cardTime: "",
        remark: "备注", //
        userPhone: "", //家长手机号
        totalPay: "", //家长支付金额
        user: {
          name: "未搜到用户",
        },
        options: [],
        storeLessonCardId: "",
      },

      cardInfo: "",
      userDetailInfo: "",
      wordTitle: "",
      refreshWord: "",
      updateRefresh: "",
      updateChildId: 0,
      wordType: 0,
      tData: "",
      showWordDlg: false,

      stopCardDate: "", //停卡日期
      curRow: "",

      //调整卡参数
      updateCardParam: {
        updateEndDate: "", //调整卡结束日期
        remTotalCount: "",
        remGiveCount: "",
        pay: "",
        remark: "",
        value1: []
      },

      //续卡参数
      renewalParam: {
        oldCardId: 0,
        lessonCardId: 0,
        storeFrontId: 0,
        pay: 0,
        adminId: "",
        inviteWorker: null,
        buyCardWorker: null,
      },
      lessonTemplateId: enumsUtil.lessonTemplateIdBS(),
      cardUseTypeList: ECardUseType(),
      allWorker: [],
      detailId: null,
      fechListList: [],
      //详情页参数
      detailInfo: {
        gender: "",
        userPhone: "",
        childName: "",
        cardName: "",
        cardNames: "",
        experience: "",
        totalLesssonCount: "",
        totalGiveCount: "",
        totalPay: "",
        givenPay: "",
        realPay: "",
        remTotalPay: "",
        createTime: "",
        inviteWorker: "",
        buyCardWorker: "",
        buyCardWorkerTwo: "",
        source: "",
        sourceTwo: "",
        remark: "",
      },
      isVip: globaldata.getAdminStore().isVip,

    };
  },
  mounted() {
    globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);

    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    let lett = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        lett.onPressEnter();
      }
    };
    this.fechListLess()
    this.qlLessonTem()
  },
  methods: {
    qlLessonTem(){
      qlLessonTemplate({
        lessonId: 2,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessonsList = res.data
        }
      })
    },
    clickAudio(val) {
      this.audioDialog = true
      console.log(val, this.$refs.audioDialogRef, 'refs.audioDialogRef=======')
      this.$nextTick(() => {
        this.$refs.audioDialogRef.audio = val.recordingTo
      })
    },
    handleUpdateDeduction() {
      messageUtils.successMsg(this, '扣课成功');
      this.visibleDlgDeduction = false;
      this.flechList();
    },
    handleDeductionShowDlg() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      let times = [this.selectRow.cardStartTime, this.selectRow.cardEndTime]
      this.selectRow.times = times
      this.$set(this.selectRow,'cardNameCopy',this.selectRow.cardName)
      this.visibleDlgDeduction = true;
    },
    getWorker(id) {
      for (let i = 0; i < this.allWorker.length; ++i) {
        if (this.allWorker[i].id == id) {
          return this.allWorker[i].name;
        }
      }
      return "";
    },
    getStoreWorkersInfo(list) {
      // console.info(list)
      this.allWorker.push({ id: null, name: "无" });
      this.allWorker = this.allWorker.concat(list);
    },
    //查看详情
    handleDetail(index, row) {
      console.info(row);
      this.detailInfo = row;
      // console.info(111111);
      // console.info(this.visibleDetail);
      this.visibleDetail = true;
      if (this.detailInfo.gender == 0) {
        this.detailInfo.gender = "男";
      } else {
        this.detailInfo.gender = "女";
      }
      if (this.detailInfo.experience == 0) {
        this.detailInfo.experience = "vip卡";
      } else {
        this.detailInfo.experience = "体验卡";
      }
      this.detailInfo.inviteWorker = this.getWorker(
        this.detailInfo.inviteWorker
      );
      this.detailInfo.buyCardWorker = this.getWorker(
        this.detailInfo.buyCardWorker
      );
      this.detailInfo.buyCardWorkerTwo = this.getWorker(
        this.detailInfo.buyCardWorkerTwo
      );
      this.visibleDetail = true;
    },
    /**
     * 响应enter按钮
     */
    onPressEnter(e) {
      var _this = this;
      _this.flechList();
    },
    fechListLess() {
      let param = {
        pageNum: 1, //当前第几页
        pageSize: 9999,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }
      fechListLessonVipCard(param).then((res) => {
        if (res.code == 20000) {
          this.fechListList = res.data.list
        }
        // console.log( this.fechListList,'============res====')
      })
    },
    flechList() {
      this.listLoading = true;
      let param = {
        lessonsId: this.queryParam.lessonCardId,
        userName: this.queryParam.userName,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        userPhone: this.queryParam.userPhone,
        childName: this.queryParam.childName,
        lessonTemplateId: enumsUtil.lessonTemplateIdBS(),
        pageNum: this.queryParam.pageNum, //当前第几页
        pageSize: this.queryParam.pageSize,
        startHost: this.queryParam.startHost,
        endHost: this.queryParam.endHost,
        status: this.queryParam.status,
        storeLessonCardId: this.queryParam.storeLessonCardId
      };
      qlUserByCardChild(param).then((response) => {
        this.listLoading = false;
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.queryParam.totalPage = date.total;
        this.refreshData(date.list);
      });
    },
    clickSelect(row, column, event) {
      console.log(row, column, event, 'this.selectRow===')
      this.selectList = row
    },
    clickselectAll(row, column, event) {
      console.log(row, column, event, 'this.selectRow===')
      this.selectList = row
    },
    rowClick(row, column, event) {
      this.selectRow = row;
    },
    // 实现双击复制的事件
    celldblclick(row, column, cell, event) {
      if (event.type === "dblclick") {
        var save = function (e) {
          e.clipboardData.setData("text/plain", row[column.property]);
          e.preventDefault(); //阻止默认行为
        };
        this.$message({
          message: "复制成功:" + row[column.property],
          type: "success",
        }); //复制成功后提示
        document.addEventListener("copy", save);
        document.execCommand("copy");
        document.removeEventListener("copy", save);
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 0 ||
        columnIndex === 1 ||
        columnIndex === 2 ||
        columnIndex === 3
      ) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      let tableDataList = [];
      let now = new Date();
      this.spanArr = [];
      this.pos = 0;
      for (let i = 0; i < list.length; ++i) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同  inAccessCode（批次字段）
          if (list[i].id === list[i - 1].id) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        let totalLesssonCountDes =
          list[i].totalLesssonCount +
          list[i].totalGiveCount +
          "(" +
          list[i].totalLesssonCount +
          "/" +
          list[i].totalGiveCount +
          ")";
        let remainingClassDes =
          list[i].remainingClass +
          list[i].remainingGiveCount +
          "(" +
          list[i].remainingClass +
          "/" +
          list[i].remainingGiveCount +
          ")";
        let childTypeDes = "";
        if (list[i].childType == 1) {
          childTypeDes = "";
        } else if (list[i].childType == 2) {
          childTypeDes = "幼儿";
        }
        let startV = list[i].cardStartTime;
        let cardSt = new Date(list[i].cardStartTime);
        if (cardSt.getTime() < now.getTime()) {
          startV = now;
        } else {
          startV = cardSt;
        }
        let valDay = timeUtils.getDaysBetween(startV, list[i].cardEndTime) + 1;
        if (valDay <= 0) {
          valDay = "已过期";
        }
        let statuDes = list[i].statu;
        statuDes = EUserBuyCardStatu(list[i].statu);
        let useTypeDes = getEnumDesByV(list[i].useType, ECardUseType());
        let data = {
          number: i + 1,
          id: list[i].id,
          childId: list[i].childId,
          userId: list[i].userId,
          payTime: list[i].payTime,
          cardStartTime: list[i].cardStartTime,
          recordingTo: list[i].recordingTo,
          lessonTemplateType: this.getBuyCardBusenss(list[i].lessonsId),
          // lessonTemplateType: this.getBuyCardBusenss(list[i].storeLessonCardId),
          cardEndTime: list[i].cardEndTime,
          valDay: valDay,
          storeLessonCardId: list[i].storeLessonCardId,
          totalPay: list[i].totalPay,
          remTotalPay: list[i].remTotalPay,
          totalLesssonCount: list[i].totalLesssonCount,
          totalGiveCount: list[i].totalGiveCount,
          remainingClass: list[i].remainingClass,
          remainingGiveCount: list[i].remainingGiveCount,
          frequency: list[i].frequency,
          startTime: list[i].startTime,
          endTime: list[i].endTime,
          consumeType: list[i].consumeType,
          monthC: list[i].monthC,
          childTypeDes: childTypeDes,
          useType: list[i].useType,
          totalLesssonCountDes: totalLesssonCountDes,

          remainingClassDes: remainingClassDes,
          childName: list[i].childName,
          remark: list[i].remark,
          cardName: list[i].cardName,
          cardNames: list[i].cardName,
          userName: list[i].userName,
          userPhone: list[i].phoneNumber,
          petName:list[i].petName,
          childBirthday:list[i].childBirthday,
          statu: list[i].statu,
          source: list[i].source,
          sourceTwo: list[i].sourceTwo,
          gender: list[i].gender,
          experience: list[i].experience,
          realPay: list[i].realPay,
          remTotalPay: list[i].remTotalPay,
          createTime: list[i].createTime,
          inviteWorker: list[i].inviteWorker,
          buyCardWorker: list[i].buyCardWorker,
          buyCardWorkerTwo: list[i].buyCardWorkerTwo,
          givenPay: list[i].givenPay,
          gift: list[i].gift,
          statuDes: statuDes,
          useTypeDes: useTypeDes,
          buyRemarkFileList: list[i].buyRemarkFileList,
          lessonTemplateId: list[i].lessonTemplateId,
          gold: list[i].gold,
        };
        tableDataList.push(data);
      }
      this.tableData = tableDataList;
    },

    //获取店铺所有VIP卡
    getStoreLessonCard(data) {
      this.storeLessonCards = [];
      for (let i = 0; i < data.length; ++i) {
        //去除体验卡和亲子游的
        if (
          data[i].experience == 0 &&
          data[i].storeLessonCardTemplateId == enumsUtil.lessonTemplateIdBS()
        ) {
          this.storeLessonCards.push(data[i]);
        }
      }
      this.flechList();
    },
    getStoreLessonTemplate(data) {
      this.lessonCardTemplate = data;
      globaldata.getStoreLessonCard(this.getStoreLessonCard);
    },
    /**
     * 通过用户的卡得到用户的版本
     * @param id
     * @returns {*}
     */
    // getBuyCardBusenss(storeLessonCardId) {
    //   for (let i = 0; i < this.storeLessonCards.length; ++i) {
    //     if (this.storeLessonCards[i].id == storeLessonCardId) {
    //       let lc = this.storeLessonCards[i];
    //       for (let j = 0; j < this.lessonCardTemplate.length; ++j) {
    //         if (lc.storeLessonCardTemplateId == this.lessonCardTemplate[j].id) {
    //           return this.lessonCardTemplate[j].type;
    //         }
    //       }
    //     }
    //   }
    // },
    getBuyCardBusenss(storeLessonCardId){
      for (let i = 0; i < this.storeLessonsList.length; ++i) {
        if (this.storeLessonsList[i].storeLessonId == storeLessonCardId){
              return this.storeLessonsList[i].name;
        }
      }
    },
    

    //点击查询按钮
    onBtnSearch() {
      this.flechList();
    },
    // 点击重置按钮
    handleResetSearch() {
      this.queryParam = {
        payTime: "",
        storeLessonCardId: '',
        startHost: undefined,
        endHost: undefined,
        cardTime: "",
        totalPay: "3000",
        sliderValue: [0, 500],
        sliderMarks: {
          0: "0",
          100: "100",
          500: "500",
        }
      }
      this.flechList();
    },
    handleSearchUser() {
      let param = {
        phoneNumber: this.createParam.userPhone,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };
      findVipUser(param).then((response) => {
        console.log(response);
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          this.createParam.user.name = "未搜到用户";
          return;
        }
        this.createParam.user = data;
      });
    },
    handleCheckSelect() {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      return true;
    },
    handleBookLesson(from) {
      // console.log("handleBookLesson", from);
      // if (!this.handleCheckSelect()) {
      //   return;
      // }
      if(from == 1){
        if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      }
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      this.refreshBookDlg = new Date().getTime();
      this.handleBookLessonNum = from;
      this.visibleDlgBookThree = true;
      this.$nextTick(() => {
        if (this.handleBookLessonNum == 1) {
          // console.log(this.$refs.onForChild,'this.$refs.==============')
          this.$refs.onForChild.templateId = 1
        }
      })
    },
    handleActitity() {
      if (!this.handleCheckSelect()) {
        return;
      }
      this.refreshBookDlg = new Date().getTime();
      this.isVip = false;
      this.visibleDlgBook = true;
    },
    handleUpdatevisibleVipUpdateType() {
      this.visibleVipUpdateType = false;
      this.selectRow = null;
      this.flechList();
    },
    handleSelectionChange(val) { 
      this.multipleSelection = val
      this.selectList = val
      console.log(this.multipleSelection, '===============')
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.flechList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.flechList();
    },

    //添加一个
    handleCreateOneDlg() {
      // this.showAddCardDlg = true;
      // this.refreshCard = new Date().getTime();
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      this.updateChildId = this.selectRow.childId;
      this.visibleVipUpdateType = true;
      this.$nextTick(()=>{
        this.$refs.UpdateVipTypeInfo.initParam()
      })
    },
    handleCreateOne() {
      this.refreshCard = new Date().getTime();
      this.visibleDlgAdd = false;
      this.flechList();
    },
    handlerenewalDlg(index, tableData) {
      this.renewalParam.id = tableData[index].id;
      this.renewalParam.userName = tableData[index].userName;
      this.renewalParam.userPhone = tableData[index].userPhone;
      this.renewalParam.cardName = tableData[index].cardName;
      this.renewalParam.adminId = 0;
      this.renewalParam.count = 0;
      this.renewalParam.pay = 0;
      this.visibleDlgrenewal = true;
    },

    handleWord(wordType, tData) {
      console.log("handleWord", wordType, tData);
      //续课时
      if (wordType == 1) {
        this.doHandlerenewal(tData);
      } else if (wordType == 2) {
        this.doHandleStopCard(tData);
      } else if (wordType == 3) {
        this.dohandleRestartCard(tData);
      } else if (wordType == 4) {
        this.dohandleUpdateCard(tData);
      }
    },

    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = show;
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.refreshWord = new Date().getTime();
      this.showWordDlg = false;
    },

    showVisibleDlgUpdate(index, tableData) {
      this.updateParam = {
        id: tableData[index].id,
        lessonName: tableData[index].lessonName,

        lessonTemplateId: tableData[index].lessonTemplateId,
        lessonLevel: tableData[index].lessonLevel,
        shopFrontId: tableData[index].shopFrontId,
        bookTime: tableData[index].bookTime,
        classTime: tableData[index].classTime,
        canBookStartTime: tableData[index].canBookStartTime,
        canBookEndTime: tableData[index].canBookEndTime,
        classStartTime: tableData[index].classStartTime,
        classEndTime: tableData[index].classEndTime,
        releaseTime: tableData[index].releaseTime,
        releaseAdminId: tableData[index].releaseAdminId,
        maxBookPeople: tableData[index].maxBookPeople,
        tearchersInfo: tableData[index].tearchersInfo,
        remark: tableData[index].remark,
      };
      this.visibleDlgupdate = true;
    },
    handleUpdate() {
      this.visibleDlgupdate = false;
    },

    beforeHandleCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command,
      };
    },

    handleCommand(command) {
      console.log(command,'command')
      switch (command.command) {
        case "updateCard": //调整卡
          this.handleUpdateCardShowDlg(command.row);
          break;
        case "rewCard": //续卡
          this.handleRenewalsCardShowDlg(command.row);
          break;
        case "stopCard": //停卡
          this.handleStopCardShowDlg(command.row);
          break;
        case "restartCard": //重开卡
          this.handlereStartCardShowDlg(command.row);
          break;
      }
    },

    //续卡

    handleRenewalsCardShowDlg() {
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      let row = this.selectRow;
      // if (!this.handleCheckSelect()) {
      //   return;
      // }
      this.curRow = row;
      this.setCardInfo(row);
      this.renewalParam = {
        oldCardId: row.id,
      };
      this.visibleDlgrenewal = true;
    },

    doHandlerenewal(data) {
      renewalsCard(data).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
        } else {
          messageUtils.successMsg(this, response.message);
          this.visibleDlgrenewal = false;
          this.flechList();
        }
      });
    },

    handlerenewal() {
      let param = {
        oldCardId: this.renewalParam.oldCardId,
        lessonCardId: this.renewalParam.lessonCardId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        pay: this.renewalParam.pay,
        adminId: globaldata.getAdminStore().id,
        inviteWorker: this.renewalParam.inviteWorker,
        buyCardWorker: this.renewalParam.buyCardWorker,
      };
      this.doRefreshWord(true, 1, param);
    },

    dohandleUpdateCard(data) {
      updateCardDetail(data).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
        } else {
          messageUtils.successMsg(this, response.message);
          this.visibleUpdateCard = false;
          this.flechList();
        }
      });
    },
    // 修改会员信息
    onUpdateChildInfoShow() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      this.updateChildId = this.selectRow.childId;

      this.visibleDlgUpdateChildInfo = true;

      this.updateRefresh = new Date().getTime();
    },
    //调整卡

    handleUpdateCardShowDlg() {
      // let row = this.selectRow;
      // console.log(row, "row");
      // if (!this.handleCheckSelect()) {
      //   return;
      // }
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      let row = this.selectRow;
      this.curRow = this.selectRow;
      this.setCardInfo(row);
      this.updateCardParam = {
        updateEndDate: row.cardEndTime, //调整卡结束日期
        remTotalCount: 0,
        remGiveCount: 0,
        pay: 0,
        useType: row.useType,
        remark: "",
        frequency: row.frequency,
        value1: [row.startTime, row.endTime],
      };
      this.visibleUpdateCard = true;
    },
    handleUpdateCard() {
      let param = {
        userBuyCardId: this.curRow.id,
        adminId: globaldata.getAdminStore().id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        endDate: this.updateCardParam.updateEndDate,
        remTotalCount: this.updateCardParam.remTotalCount,
        remGiveCount: this.updateCardParam.remGiveCount,
        pay: this.updateCardParam.pay,
        useType: this.updateCardParam.useType,
        remark: this.updateCardParam.remark,
        frequency: this.updateCardParam.frequency,
        startTime: this.updateCardParam.value1[0],
        endTime: this.updateCardParam.value1[1]
      };
      this.doRefreshWord(true, 4, param);
    },

    dohandleUpdateCard(data) {
      updateCardDetail(data).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
        } else {
          messageUtils.successMsg(this, response.message);
          this.visibleUpdateCard = false;
          this.flechList();
        }
      });
    },

    handlereStartCardShowDlg() {
      let row = this.selectRow;
      if (!this.handleCheckSelect()) {
        return;
      }
      this.curRow = row;
      this.setCardInfo(row);
      this.visibleRestartCard = true;
    },
    handleRestartCard(data) {
      let param = {
        id: this.curRow.id,
        adminId: globaldata.getAdminStore().id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        remark: data.remark
      };
      this.doRefreshWord(true, 3, param);
    },

    dohandleRestartCard(data) {
      reStartBuyCard(data).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
        } else {
          messageUtils.successMsg(this, response.message);
          this.visibleRestartCard = false;
          this.flechList();
        }
      });
    },

    handleStopCardShowDlg() {
      // if (!this.handleCheckSelect()) {
      //   return;
      // }
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      let row = this.selectRow;
      this.curRow = row;
      this.setCardInfo(row);
      this.visibleStopCard = true;
    },
    handleStopShunt() {
      messageUtils.successMsg(this, "分流成功");
      this.$nextTick(()=>{
        this.visibleDlogShunt = false;
        this.flechList();
      })
    },
    handleCurrentCardEvent(data) {

      if (data.radio == 1) {
        this.handleStopCard(data)
      } else if (data.radio == 2) {
        this.handleRestartCard(data)
      }
    },
    handleStopCard(data) {
      let param = {
        id: this.curRow.id,
        adminId: globaldata.getAdminStore().id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        startDate: data.stopCardDate && data.stopCardDate.length ? data.stopCardDate[0] : '',
        endDate: data.stopCardDate && data.stopCardDate.length ? data.stopCardDate[1] : '',
        remark: data.remark
      };
      this.doRefreshWord(true, 2, param);
    },

    doHandleStopCard(data) {
      stopBuyCard(data).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
        } else {
          messageUtils.successMsg(this, response.message);
          this.visibleStopCard = false;
          this.flechList();
        }
      });
    },

    setCardInfo(row) {
      this.cardInfo = {
        userPhone: row.userPhone,
        cardName: row.cardName,
        cardNames: row.cardName,
        cardNumber:row.id,
        childName: row.childName,
        totalClassCount: row.totalLesssonCount,
        giveClassCount: row.totalGiveCount,
        remTotalClassCount: row.remainingClass,
        remGiveClassCount: row.remainingGiveCount,
        cardEndTime: row.cardEndTime,
        totalPay: row.totalPay,
        consumeType: row.consumeType,
        frequency: row.frequency,
        value1: [row.startTime, row.endTime],
      };
    },
    onBookSuccess() {
      this.visibleDlgBook = false;
      this.visibleDlgBookThree = false;
      this.flechList();
    },

    handleUpdateChild() {
      this.visibleDlgUpdateChildInfo = false;
      this.selectRow = null;
      this.flechList();
    },
    onBtnCancelUpdate() {
      this.visibleDlgUpdateChildInfo = false;
    },

    handleExtendAllCardDayShowDlg() {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      this.visibleDlgExtentCardDay = true;
    },

    handleExtendAllCardDay() {
      this.visibleDlgExtentCardDay = false;
      this.flechList();
    },
    handelChildPhoto() {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      this.$router.push({
        path: "/vip/childPhotoList",
        query: { childId: this.selectRow.childId },
      });
    },
    handleFilesUpload() {
      this.visibleFileupload = true;
    },
    fileUploadSuccess() {
      this.visibleFileupload = false;
      this.flechList();
    },
    handleDIGShunt() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      if (this.isVip == 0 || this.isVip == 1) return this.$message.warning("该功能需要开通SVIP功能，请先开通相关权益！");
      if(this.multipleSelection.length == 0 ){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      this.visibleDlogShunt = true;
      // if (this.selectList && this.selectList.length) {
        
      // } else {
      //   messageUtils.errorMsg(this, "请先选择数据");
      // }
    },
    handleUpAgreement() {
      // if (commonUtils.isObjectNull(this.selectRow)) {
      //   messageUtils.errorMsg(this, "请先选择一条信息");
      //   return false;
      // }
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      // this.$router.push({
      //   path: "/vip/agreement",
      //   query: {
      //     workerId: this.selectRow.id,
      //     type: "2",
      //     phoneNumber: this.selectRow.phoneNumber,
      //     cardName: this.selectRow.cardName,
      //     userName: this.selectRow.userName,
      //     lessonTemplateId: this.selectRow.lessonTemplateId,
      //   },
      // });
      this.visibleUploadContract = true;
    },
    goGoldExchange(row) {
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      this.$router.push({ path: "/vip/goldRecord", query: { cardId: row.id } });
    },
    clickOpenModelBtns(row, from) {
      this.detailId = row.id
      switch (from) {
        case 1:
          // 订
          this.contentShow = false;
          break;
        case 2:
          // 会
          if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
          this.vipInfo = row
          this.visibleVipModelShow = true;
          break;
      }
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/UserBuyLessonCardBs.vue